import { throwError, Observable } from 'rxjs';
import { ServiceBase } from '@app/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Instancia } from '@app/models/processo.model';
import { catchError } from 'rxjs/operators';

@Injectable()
export class InstanciaService extends ServiceBase {
  constructor(private http: HttpClient) {
    super();
  }

  gravar(instancia: Instancia): Observable<any> {
    return this.http.post<any>(this.URL_API + 'configuracoes/instancia/gravar', instancia).pipe(
      catchError((error: any) => throwError(error)));
  }

  obterTodos(): Observable<Instancia[]>{
    return this.http.get<Instancia[]>(this.URL_API + 'configuracoes/instancia/lista').pipe(
      catchError((error: any) => throwError(error)));
  }

  obterTodosOrdenado(): Observable<Instancia[]>{
    return this.http.get<Instancia[]>(this.URL_API + 'configuracoes/instancia/listaOrdenada').pipe(
      catchError((error: any) => throwError(error)));
  }

  deletar(id: number): Observable<any> {
    return this.http.delete<any>(this.URL_API + `configuracoes/instancia/deletar/${id}`).pipe(
      catchError((error: any) => throwError(error)));
  }

  obterPorId(id: number): Observable<Instancia> {
    return this.http.get<Instancia>(this.URL_API + `configuracoes/instancia/obter-por-id/${id}`).pipe(
      catchError((error: any) => throwError(error)));
  }
}
